import Layers from "slotworks/graphics/layers/layers";
import { AbstractSceneTransition } from "slotworks/graphics/layers/scene-transitions/abstract-scene-transition";
import Contract from "slotworks/utils/contracts/contract";
import * as TweenJS from "slotworks/utils/tween";

export default class FreespinsBetbarToDefaultTransition extends AbstractSceneTransition {

    private static fadeoutTime: number = 500;

    public in(): Contract<void> {

        return Contract.empty();
    }

    public out(): Contract<void> {
        return new Contract<void>((resolve) => {
            const background = Layers.BetBar.getSprite("spins_background");
            const value = Layers.BetBar.getFlexiText("freespins_x_of_y_value");
            const label = Layers.BetBar.getFlexiText("freespins_x_of_y_label");

            new TweenJS.Tween(label)
                .to({alpha: 0}, FreespinsBetbarToDefaultTransition.fadeoutTime)
                .onComplete(() => {
                    resolve(null);
                })
                .start();

            new TweenJS.Tween(value)
                .to({alpha: 0}, FreespinsBetbarToDefaultTransition.fadeoutTime)
                .start();

            if (background) {
                new TweenJS.Tween(background)
                    .to({alpha: 0}, FreespinsBetbarToDefaultTransition.fadeoutTime)
                    .start();
            }

        });
    }
}
